/**
 * IGNITE-85: discard cached carts once their window has passed.
 *
 * The cart is persisted to localStorage and nothing on the server knows it
 * exists, so this is the only thing that ages it out. Two trigger points:
 *
 *  - once on startup, covering the customer who returns the next day;
 *  - on every navigation, covering the tab left open overnight. Checking out
 *    requires navigating, so a stale cart cannot reach the order without
 *    passing through here.
 *
 * No timer: expiring a cart under a customer who is sitting and looking at it
 * would be worse than expiring it the moment they act on it.
 */
export default defineNuxtPlugin((nuxtApp) => {
  const check = () => {
    try {
      useCommerceStore().discardCartIfExpired();
    } catch (error) {
      // Never let cart housekeeping break navigation
      console.error("[Cart] Expiry check failed:", error);
    }
  };

  nuxtApp.hook("app:mounted", check);

  const router = useRouter();
  router.beforeEach((to, from, next) => {
    check();
    next();
  });
});
